import { useTranslate } from '@va/localization';
import { useMemo } from 'react';
import {
  DomainBlacklistingCard,
  DomainWhitelistingCard,
  ErrorAlerts,
  FirstWeekDayCard,
  IgnoreOwnVisitsCard,
  NotificationPreferences,
  TimezoneCard,
  TrafficAlerts,
  UrlAppearanceCard,
  WebsiteRegionAndBusinessSectorCard,
} from '.';

export const useCommonGeneralSettingsCards = () => {
  const translate = useTranslate();

  const cards = useMemo(
    () => ({
      firstWeekDay: {
        id: 'first-day-of-week',
        title: translate('settings.navigation.firstWeekDay.title'),
        component: <FirstWeekDayCard />,
      },
      websiteRegionAndBusinessSector: {
        id: 'website-region-and-business-sector',
        title: translate('settings.navigation.websiteRegionAndBusinessSector.title'),
        component: <WebsiteRegionAndBusinessSectorCard />,
      },
      notificationPreferences: {
        id: 'notification-preferences',
        title: translate('settings.navigation.notificationPreferences.title'),
        component: <NotificationPreferences />,
      },
      timezone: {
        id: 'date-and-time',
        title: translate('settings.navigation.timezone.title'),
        component: <TimezoneCard />,
      },
      ignoreOwnVisits: {
        id: 'ignore-own-visits',
        title: translate('settings.navigation.ignoreSelfTracking.title'),
        component: <IgnoreOwnVisitsCard />,
      },
      urlAppearance: {
        id: 'url-appearence',
        title: translate('settings.navigation.urlAppearnace.title'),
        component: <UrlAppearanceCard />,
      },
      domainWhitelisting: {
        id: 'domain-whitelisting',
        title: translate('settings.navigation.domainWhiteListing.title'),
        component: <DomainWhitelistingCard />,
      },
      domainBlackListing: {
        id: 'domain-blacklisting',
        title: translate('settings.navigation.domainBlacklisting.title'),
        component: <DomainBlacklistingCard />,
      },
      errorAlerts: {
        id: 'error-alerts',
        title: translate('settings.navigation.errorAlerts.title'),
        component: <ErrorAlerts />,
      },
      trafficAnomalies: {
        id: 'traffic-anomalies',
        title: translate('settings.navigation.trafficAnomalies.title'),
        component: <TrafficAlerts />,
      },
    }),
    [translate],
  );

  return cards;
};
